import { api } from './client';

export type SettlementSpace = 'affilmaster' | 'dmwk';
export type SettlementStatus = 'navrh' | 'schvaleno' | 'vystaveno' | 'odeslano' | 'nefakturuje';
export type SettlementCurrency = 'CZK' | 'EUR';
export interface SettlementItem { dealId: number; title: string; description: string; amount: number; productId: string; vatRate: number; change: 'new' | 'changed' | null; previousAmount: number | null }
export interface SettlementView {
  id: number; period: string; partnerId: number; partnerName: string; market: 'cz' | 'sk';
  currency: SettlementCurrency; status: SettlementStatus; items: SettlementItem[];
  removedItems: { title: string; amount: number }[];
  totalNet: number; vatRate: number; totalGross: number;
  duzp: string; issueDate: string; dueDate: string; bankAccount: string; consumptionCountry: string;
  skipReason: string | null; simulated: boolean; uolInvoiceId: string | null; uolPayload: unknown;
  uolCompanyName: string | null; uolContactId: string | null;
  mailTo: string | null; mailCc: string | null; mailSubject: string | null;
  recipients: { to: string | null; cc: string[]; copy: string | null };
  warnings: string[]; paid: boolean; error: string | null;
  mailPreview: { subject: string; bodyPlain: string } | null;
  approvedAt: string | null; issuedAt: string | null; sentAt: string | null;
}
export interface SettlementProcess {
  currency: SettlementCurrency;
  steps: { navrh: number; schvaleno: number; vystaveno: number; odeslano: number; total: number };
  net: number; gross: number; paid: number;
}
export interface SettlementOverview {
  period: string; previousPeriod: string; live: boolean; prepared: boolean; mailCopy: string | null;
  mailFrom: string | null; dueDays: number;
  rows: SettlementView[]; processes: SettlementProcess[]; skipped: number;
}
export type SettlementPeriodState = 'nepripraveno' | 'navrh' | 'schvaleno' | 'vystaveno' | 'odeslano';
export interface SettlementPeriodSummary {
  period: string; currency: SettlementCurrency; prepared: boolean; state: SettlementPeriodState; progress: number; simulated: boolean;
  clients: number; items: number; net: number; gross: number; steps: SettlementProcess['steps']; paid: number;
}
export interface SettlementPeriodsOverview { live: boolean; currentPeriod: string; periods: SettlementPeriodSummary[] }
export interface SettlementBulkResult { done: number; failed: { partner: string; error: string }[]; overview: SettlementOverview }
const base = (space: SettlementSpace) => `/api/v1/${space}/finance/vyuctovani`;

export const getVyuctovani = (space: SettlementSpace, ym: string) =>
  api.get<SettlementOverview>(`${base(space)}?ym=${encodeURIComponent(ym)}`);
export const getVyuctovaniPrehled = (space: SettlementSpace) =>
  api.get<SettlementPeriodsOverview>(`${base(space)}/prehled`);
export const vyuctovaniPdfUrl = (space: SettlementSpace, id: number) => `${base(space)}/${id}/faktura.pdf`;
export const getVyuctovaniDetail = (space: SettlementSpace, id: number) =>
  api.get<SettlementView>(`${base(space)}/${id}`);
export const prepareVyuctovani = (space: SettlementSpace, ym: string) =>
  api.post<SettlementOverview>(`${base(space)}/prepare`, { ym });
export const resetVyuctovani = (space: SettlementSpace, ym: string, currency: SettlementCurrency) =>
  api.post<{ rows: number; overview: SettlementOverview }>(`${base(space)}/reset`, { ym, currency });
export const bulkVyuctovani = (space: SettlementSpace, ym: string, action: 'approve' | 'issue' | 'send', currency: SettlementCurrency, ids?: number[]) =>
  api.post<SettlementBulkResult>(`${base(space)}/${action}-all`, { ym, currency, ids });
export const testMailVyuctovani = (space: SettlementSpace, id: number) =>
  api.post<{ to: string; attachment: string | null }>(`${base(space)}/${id}/test-mail`, {});
export const actVyuctovani = (space: SettlementSpace, id: number, action: 'approve' | 'unapprove' | 'issue' | 'send') =>
  api.post<SettlementView>(`${base(space)}/${id}/${action}`, {});
